<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import usePlaylistStore from '../../stores/playlist';
import useLocale from '../../composables/useLocale';

const { t } = useLocale();
const { totalDuration, currentPlaylistTime } = storeToRefs(usePlaylistStore());

const remainingSeconds = computed(() => {
  return Math.max(0, totalDuration.value - currentPlaylistTime.value);
});

const bookRemainingFormatted = computed(() => {
  const seconds = remainingSeconds.value;

  if (!isFinite(seconds) || seconds < 0) {
    return `0 ${t('book_player.label_duration_hours_short')} 0 ${t('book_player.label_duration_minutes_short')}`;
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours} ${t('book_player.label_duration_hours_short')} ${minutes} ${t('book_player.label_duration_minutes_short')}`;
  }

  if (minutes > 0) {
    return `${minutes} ${t('book_player.label_duration_minutes_short')}`;
  }

  return `${secs} ${t('book_player.label_duration_seconds_short')}`;
});
</script>

<template>
  <div v-if="remainingSeconds > 0" class="book-remaining-time text-center py-2" data-testid="bp-book-remaining-time">
    <span class="text-caption"> {{ bookRemainingFormatted }} {{ t('book_player.label_remaining_of_book') }} </span>
  </div>
</template>

<style scoped lang="scss">
.book-remaining-time {
  user-select: none;
}
</style>
